// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"552fb150","294":"94b804c2","305":"f606bab5","436":"34aefd4b","453":"647bbbac","690":"075a730a","938":"f2a9407c","947":"87cfe28e"}[chunkId] + ".chunk.js";
};